import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  // User object TODO: Make a user model?
  user = {
    email: '',
    firstName: '',
    lastName: '',
  }

  constructor(private http: HttpClient, private router: Router) { }

  // Send request to backend to get profile information (account-info)
  getProfile() {
    return this.http.get('api/v1/adminUsers/profile');
  }

  // Send request to backend to get profile information (account-info)
  updateSelf(adminInfo: any) {
    return this.http.post('api/v1/adminUsers/update-self', adminInfo);
  }

  // Send request to backend to get profile information (account-info)
  updateUser(adminInfo: any) {
    return this.http.post('api/v1/adminUsers/update-user', adminInfo);
  }

  // Get all agencies
  getAgencies() {
    return this.http.get('api/v1/agencies/get');
  }

  // Get all active agencies
  getActiveAgencies() {
    return this.http.get('api/v1/agencies/getActive');
  }

  updateAgency(agency: any) {
    return this.http.post('api/v1/agencies/update', agency);
  }

  // Add agency
  addAgency(agency: any) {
    return this.http.post('api/v1/agencies/add', agency);
  }

  // Invite New Admin
  inviteAdmin(model: any) {
    return this.http.post('api/v1/adminUsers/invite', model);
  }

  // Send request for new admin to register
  registerAdmin(model: any) {
    return this.http.post('api/v1/public/registerAdmin', model);
  }

  // Send request for to get admin info for a new register
  getNewRegister(token: any) {
    return this.http.post('api/v1/public/getNewAdminRegister',  { token: token });
  }

  // Register agent users uploaded in CSV file
  registerMany(courseid: string, agencyid: string|null, users: any[]) {
    return this.http.post('api/v1/users/register-many', { courseid, agencyid, users });
  }

  deregisterCourses(agencyid: string|null, userid: string) {
    return this.http.post('api/v1/users/deregister', { agencyid, userid });
  }

  getInvitationLink() {
    return this.http.get<any>('api/v1/users/invitation-link').pipe(map(res => res.link as string));
  }

  sendInvitations(emails: string[]) {
    return this.http.post('api/v1/users/invite', { emails });
  }

  deleteUser(userid: string) {
    return this.http.post('api/v1/adminUsers/delete-user', { userid });
  }

  getBannedList(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/adminUsers/get-banned-list', { params: queryParams });
  }

  banUser(email: string, activity?: string) {
    return this.http.post('api/v1/adminUsers/add-banned-list-entry', { email, activity });
  }

  unbanUser(email: string, activity?: string) {
    return this.http.post('api/v1/adminUsers/remove-banned-list-entry', { email, activity });
  }

  getChallengesCount(): Observable<number> {
    return this.http.get<any>('api/v1/properties/challenges-count').pipe(map(res => res.count));
  }

  getChallenges(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get('api/v1/properties/challenges', { params: queryParams });
  }

  deleteChallenge(challengeID: string) {
    return this.http.post('api/v1/properties/delete-challenge', { challengeID });
  }

  deleteQuizQuestion(id: string) {
    return this.http.post('api/v1/quizzes/delete-question', { questionID: id });
  }

  updateQuizQuestion(id: string, data: object) {
    return this.http.post('api/v1/quizzes/update-question', { questionID: id, data });
  }

  addQuizQuestion(moduleID: string, question: object) {
    return this.http.post('api/v1/quizzes/add-question', { moduleID, question });
  }

  getGeoJsonLink(scope: string, query?: Indexable) {
    return this.http.get<any>(`api/v1/adminUsers/geojson/link/${scope}`, { params: query }).pipe(map(res => res.link as string));
  }

  getGeoRssLink(scope: string, query?: Indexable) {
    return this.http.get<any>(`api/v1/adminUsers/georss/link/${scope}`, { params: query }).pipe(map(res => res.link as string));
  }

  impersonate(role: string, email: string) {
    return this.http.post<any>('api/v1/adminUsers/impersonate', { email, role });
  }

  getAll(query?: Indexable) {
    let queryParams = new HttpParams({ fromObject: query });

    return this.http.get<any>('api/v1/adminUsers/get-all', { params: queryParams });
  }

  deleteAdmin(userid: string) {
    return this.http.post('api/v1/adminUsers/delete-admin', { userid });
  }

  deleteCoursePage(courseid: string, moduleid: string, pageid: string) {
    return this.http.post('api/v1/courses/delete-page', { courseid, moduleid, pageid });
  }

  updateCoursePage(courseid: string, moduleid: string, pageid: string, data: any) {
    const body = { ...data, courseid, moduleid, pageid };
    return this.http.post('api/v1/courses/update-page', body);
  }

  deleteCourseModule(courseid: string, moduleid: string, params?: Indexable) {
    return this.http.post('api/v1/courses/delete-module', { ...params, courseid, moduleid });
  }

  updateCourseModule(courseid: string, moduleid: string, data: any) {
    const body = { ...data, courseid, moduleid };
    return this.http.post('api/v1/courses/update-module', body);
  }

  addCourseModule(courseid: string, data: any) {
    const body = { ...data, courseid };
    return this.http.post('api/v1/courses/add-module', body);
  }

  addCoursePage(courseid: string, moduleid: string, data: any) {
    const body = { ...data, courseid, moduleid };
    return this.http.post('api/v1/courses/add-page', body);
  }
}
